import JoyLogo from "../../../assests/Images/TemplateElement/JoyPinkLogo.png";
import { DATE } from "../../../shared/constants.js";
import VideoCardTemplate from "./VideoTemplate";

function ImageTemplateBlue({ heading, caption, date, media, journalId,pageRefresh,ref,menuShow,phone }) {
  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <VideoCardTemplate
        journalId={journalId}
        imgSrc={media}
        text={caption || heading || ""}
        date={date || DATE.JOURNAL_FORMAT}
        borderColor="none" // Custom green border
        backgroundColor="none" // Custom blue background
        imageBottomRight={JoyLogo}
        imageBottomRightStyle={{
          width: { xs: 14, sm: 22, md: 22 },
          height: { xs: 14, sm: 22, md: 22 },
        }}
        textColor="#ffffff"
        pageRefreshCallback={pageRefresh}
        ref={ref}
        menuShow={menuShow}
        phone={phone}
      />
    </div>
  );
}

export default ImageTemplateBlue;
